module.exports = __webpack_public_path__ + "images/emoji/elephant.e854cf3812165eac4639.png";